// Constants without _OPTIONS are used to represent Backend Value
// Constants with _OPTIONS are used to map label and value of the SelectFieldOptions

export const IS_ACTIVE = {
  ENABLED  : 1,
  DISABLED : 0
}

export const IS_ACTIVE_OPTIONS = [
  {
    'label' : 'All',
    'value' : ''
  },
  {
    'label' : 'Enabled',
    'value' : IS_ACTIVE.ENABLED
  },
  {
    'label' : 'Disabled',
    'value' : IS_ACTIVE.DISABLED
  }
]

export const CALCULATION_TYPE = {
  ABSOLUTE   : 'absolute',
  PERCENTAGE : 'percentage'
}

export const CALCULATION_TYPE_OPTIONS = [
  {
    'label' : 'All',
    'value' : ''
  },
  {
    'label' : 'Absolute',
    'value' : CALCULATION_TYPE.ABSOLUTE
  },
  {
    'label' : 'Percentage',
    'value' : CALCULATION_TYPE.PERCENTAGE
  }
]

export const GATEWAY = {
  BANK_TRANSFER : 'bank_transfer',
  NICEPAY       : 'nicepay',
  MIDTRANS      : 'midtrans',
  KREDIVO       : 'kredivo',
  ALFATREX      : 'alfatrex'
}

export const GATEWAY_OPTIONS = [
  {
    'label' : 'All',
    'value' : ''
  },
  {
    'label' : 'Bank Transfer',
    'value' : GATEWAY.BANK_TRANSFER
  },
  {
    'label' : 'Nicepay',
    'value' : GATEWAY.NICEPAY
  },
  {
    'label' : 'Midtrans',
    'value' : GATEWAY.MIDTRANS
  },
  {
    'label' : 'Kredivo',
    'value' : GATEWAY.KREDIVO
  },
  {
    'label' : 'Alfatrex',
    'value' : GATEWAY.ALFATREX
  }
]

export const PER_PAGE = {
  5  : '5',
  10 : '10',
  25 : '25'
}

export const PER_PAGE_OPTIONS = [
  {
    'label' : 'All',
    'value' : ''
  },
  {
    'label' : PER_PAGE[5],
    'value' : PER_PAGE[5]
  },
  {
    'label' : PER_PAGE[10],
    'value' : PER_PAGE[10]
  },
  {
    'label' : PER_PAGE[25],
    'value' : PER_PAGE[25]
  }
]

export const CATEGORY = {
  BANK_TRANSFER           : 'bank_transfer',
  VIRTUAL_ACCOUNT         : 'virtual_account',
  CREDIT_CARD             : 'credit_card',
  INSTALLMENT_CREDIT_CARD : 'installment_credit_card',
  INSTANT_PAYMENT         : 'instant_payment',
  RETAIL_CASH             : 'retail_cash',
  INSTALLMENT_WITHOUT_CC  : 'installment_without_cc',
  COD                     : 'cod',
  MAGENTO                 : 'magento',
  OFFLINE                 : 'offline'
}

export const CATEGORY_OPTIONS = [
  {
    'label' : 'All',
    'value' : ''
  },
  {
    'label' : 'Bank Transfer',
    'value' : CATEGORY.BANK_TRANSFER
  },
  {
    'label' : 'Nicepay',
    'value' : CATEGORY.VIRTUAL_ACCOUNT
  },
  {
    'label' : 'Midtrans',
    'value' : CATEGORY.CREDIT_CARD
  },
  {
    'label' : 'Kredivo',
    'value' : CATEGORY.INSTALLMENT_CREDIT_CARD
  },
  {
    'label' : 'Instant Payment',
    'value' : CATEGORY.INSTANT_PAYMENT
  },
  {
    'label' : 'Retail Cash',
    'value' : CATEGORY.RETAIL_CASH
  },
  {
    'label' : 'Installment without CC',
    'value' : CATEGORY.INSTALLMENT_WITHOUT_CC
  },
  {
    'label' : 'COD',
    'value' : CATEGORY.COD
  },
  {
    'label' : 'Magento',
    'value' : CATEGORY.MAGENTO
  }
]